import z from 'zod'

import { BookingDTOState } from '@/clients/booking'

export const BookingSchema = z.object({
  id: z.string(),
  state: z.nativeEnum(BookingDTOState),
  shipperContactedAt: z.coerce
    .date()
    .nullish()
    .transform((data) => data ?? undefined),
})

export type Booking = z.infer<typeof BookingSchema>
